module.exports = __webpack_public_path__ + "static/media/logo2.611c9b70.png";